import { ModuleRegistry } from "seneca-common/features/module/registry";

import { MODULE_TYPE, TYPE } from "./consts";
import {
  checkWord,
  generateInitialUserAnswer,
  markAnswer
} from "./logic/answers";
import { getModuleAssets, transformModuleAssets } from "./logic/assets";
import { generateContent } from "./logic/content";

export type { TYPE };

export { MODULE_TYPE, checkWord, transformModuleAssets };

export const register = (moduleRegistry: ModuleRegistry) =>
  moduleRegistry
    .buildModule(MODULE_TYPE)
    .with.logic()
    .markAnswer(markAnswer)
    .generateContent(generateContent)
    .getModuleAssets(getModuleAssets)
    .generateInitialUserAnswer(generateInitialUserAnswer)
    .back.staticInformation()
    .displayName("Wordfill")
    .supportsAmeliaExplainMyAnswer()
    .root.register();
